export default __webpack_public_path__ + "static/media/Brigand's Gauntlets of the Howling Moon.c487ff31.jpg";